"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 1.12.2
var Logout = void 0;

Logout = function () {
	function Logout() {
		(0, _jquery2.default)(document).on("click", "#logout-button", function (e) {
			e.preventDefault();
			return (0, _jquery2.default)("#logout-form").submit();
		});
	}

	return Logout;
}();

exports.default = new Logout();